import { render } from "./Professional.vue?vue&type=template&id=fcd60b4c"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__